import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  styled,
} from '@mui/material';
import * as Yup from 'yup';
import {useFormik} from 'formik';
import {COLORS} from 'shared/constants/AppEnums';
import {grey} from '@mui/material/colors';
import PropTypes from 'prop-types';

const ErrorText = styled('div')({
  color: '#800000',
  fontSize: '0.875rem',
  marginLeft: '7px',
  marginTop: '4px',
});

const DialogAddKategori = forwardRef((props, ref) => {
  const [titleOptions, setTitleOptions] = useState([]);
  const [yearsOptions, setYearsOptions] = useState([]);

  useEffect(() => {
    setTitleOptions([
      {
        id: 1,
        name: 'LATIHAN DASAR',
      },
      {
        id: 2,
        name: 'PELATIHAN KEPEMIMPINAN PENGAWAS',
      },
      {
        id: 3,
        name: 'PELATIHAN KEPEMIMPINAN ADMINISTRATOR',
      },
      {
        id: 4,
        name: 'PELATIHAN KEPEMIMPINAN NASIONAL TINGKAT I',
      },
      {
        id: 5,
        name: 'PELATIHAN KEPEMIMPINAN NASIONAL TINGKAT II',
      },
    ]);

    setYearsOptions([
      {id: 1, name: new Date().getFullYear() - 1},
      {id: 2, name: new Date().getFullYear()},
    ]);
  }, []);

  const validationSchema = Yup.object({
    name: Yup.string().required('Kolom Ini Wajib Diisi!'),
    batch: Yup.number().required('Kolom Ini Wajib Diisi!'),
    members: Yup.number().required('Kolom Ini Wajib Diisi!'),
    year: Yup.number().required('Kolom Ini Wajib Diisi!'),

  });
  const formik = useFormik({
    initialValues: {
      name: '',
      batch: '',
      members: '',
      year:''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  useImperativeHandle(ref, () => ({
    returnForm() {
      Object.keys(formik.values).forEach((fieldName) => {
        formik.setFieldTouched(fieldName, true);
      });
      return formik;
    },
    resetForm() {
      formik.resetForm();
    },
  }));

  return (
    <>
      <form>
        <Box
          padding={'10px'}
          maxHeight={'380px'}
          overflow={'hidden'}
          sx={{
            '& label.Mui-focused': {
              color: COLORS.primary,
            },
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: grey[500],
              },
              '&.Mui-focused fieldset': {
                borderColor: COLORS.primary,
                color: COLORS.primary,
              },
            },
          }}
        >
          <Grid container columnSpacing={4} rowSpacing={3}>
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <InputLabel id='demo-simple-select-label'>
                  Nama Kategori
                </InputLabel>
                <Select
                  required
                  defaultValue=''
                  labelId='demo-simple-select-label'
                  id='name'
                  name='name'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  label='Nama Kategori'
                >
                  {titleOptions
                    ? titleOptions.map((item, key) => {
                        return (
                          <MenuItem key={item.id} value={item.name}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : ''}
                </Select>
              </FormControl>
              {formik.touched.name && formik.errors.name ? (
                <ErrorText>{formik.errors.name}</ErrorText>
              ) : null}
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label='Angkatan'
                id='batch'
                fullWidth
                disabled={props.role === 'detail' ? true : false}
                required
                type='number'
                name='batch'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.batch}
              />
              {formik.touched.batch && formik.errors.batch ? (
                <ErrorText>{formik.errors.batch}</ErrorText>
              ) : null}
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl sx={{width:"100%"}}>
                <InputLabel id='demo-simple-select-label'>Tahun</InputLabel>
                <Select
                  required
                  defaultValue=''
                  fullWidth
                  labelId='demo-simple-select-label'
                  id='year'
                  name='year'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.year}
                  label='Tahun'
                >
                  {yearsOptions
                    ? yearsOptions.map((item, key) => {
                        return (
                          <MenuItem key={item.id} value={item.name}>
                            {item.name}
                          </MenuItem>
                        );
                      })
                    : ''}
                </Select>
              </FormControl>
              {formik.touched.year && formik.errors.year ? (
                <ErrorText>{formik.errors.year}</ErrorText>
              ) : null}
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                label='Jumlah Peserta'
                id='members'
                fullWidth
                required
                type='number'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.members}
              />
              {formik.touched.members && formik.errors.members ? (
                <ErrorText>{formik.errors.members}</ErrorText>
              ) : null}
            </Grid>
          </Grid>
        </Box>
      </form>
    </>
  );
});

export default DialogAddKategori;

DialogAddKategori.propTypes = {
  detailData: PropTypes.any,
  role: PropTypes.string,
  uploadedFiles: PropTypes.any,
  setUploadedFiles: PropTypes.func,
};
